import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/syaycili/syaycili.github.io'
      className='link footer__link'
    >
      Made by &#128150; Sarp Yaycılı 
    </a>
  </footer>
)

export default Footer
